"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainConnectionSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.DomainConnectionSchema = __1.BaseSchema.extend({
    requestedAt: zod_1.z.coerce.date(),
    connectedAt: zod_1.z.coerce.date().optional(),
    disconnectedAt: zod_1.z.coerce.date().optional(),
    domain: zod_1.z.string(),
    subdomain: zod_1.z.string().optional(),
    status: zod_1.z.nativeEnum(__1.DomainConnectionStatus),
    sslValidationStatus: zod_1.z.nativeEnum(__1.DomainConnectionSslValidationStatus),
    sslValidationErrorType: zod_1.z.nativeEnum(__1.DomainConnectionSslValidationErrors).optional(),
    sslValidationErrorMessage: zod_1.z.string().optional(),
    sslValidationRecordName: zod_1.z.string().optional(),
    sslValidationRecordType: zod_1.z.nativeEnum(__1.DNSRecordType).optional(),
    sslValidationRecordValue: zod_1.z.string().optional(),
    domainPointingStatus: zod_1.z.nativeEnum(__1.DomainConnectionDomainPointingStatus),
    domainPointingRecordName: zod_1.z.string().optional(),
    domainPointingRecordType: zod_1.z.nativeEnum(__1.DNSRecordType).optional(),
    domainPointingRecordValue: zod_1.z.string().optional(),
    domainPointingErrorMessage: zod_1.z.string().optional(),
    domainPointingErrorType: zod_1.z.nativeEnum(__1.DomainConnectionDomainPointingErrors).optional(),
    store: __1.StoreSchema.partial().required({ id: true }),
});
//# sourceMappingURL=domain-connection.js.map